var map = {
	"./date.de-CH.json": 937,
	"./date.de-DE.json": 938,
	"./date.en-CA.json": 939,
	"./date.en-GB.json": 940,
	"./date.en-IN.json": 941,
	"./date.en-ME.json": 942,
	"./date.en-US.json": 943,
	"./date.es-EM.json": 944,
	"./date.es-ES.json": 945,
	"./date.fr-BE.json": 946,
	"./date.fr-CA.json": 947,
	"./date.fr-CH.json": 948,
	"./date.nl-BE.json": 949,
	"./date.nl-NL.json": 950,
	"./date.pl-PL.json": 951,
	"./date.pt-BR.json": 952
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 936;